// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import "./assets/css/index.css"
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from "axios";
import tool from "../src/utils/tool";
import '../src/assets/css/mvboli.css'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import NextLink from "./components/nextLink.vue";
import BreadcrumbComponent from "./components/breadcrumbComponent.vue";
import ContentMenuTitle from './components/contentMenuTitle.vue'
import { returnToTheTopOfThePage as returnTopPage } from './utils/common'

Vue.component('NextLink', NextLink)
Vue.component('BreadcrumbOnly', BreadcrumbComponent)
Vue.component('ContentMenuTitle', ContentMenuTitle)

// 挂载到全局
Vue.prototype.$returnTopPage = returnTopPage

Vue.config.productionTip = false;
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
/* eslint-disable no-new */
Vue.use(tool);
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
// 从浏览器获取默认语言
// let languages = localStorage.getItem("lang") ? localStorage.getItem("lang") : (navigator.language || navigator.userLanguage).split('-')[0]
// console.log('main', languages);
// localStorage.setItem("lang", languages);
// let current = localStorage.getItem("lang");
// console.log("languages1111111", current);
// 默认语言为日文
const i18n = new VueI18n({
  locale: "ja",
  messages: {
    en: require("./assets/i18n/en"),
    zh: require("./assets/i18n/zh"),
    ja: require('./assets/i18n/jp')
  }
});
Vue.prototype.$axios = axios
// 图片地址
// Vue.prototype.$imgUrl = "http://192.168.0.157:9102"//本地
Vue.prototype.$imgUrl = "/pachinko"//测试 正式
// Vue.prototype.$imgUrl = "/prod-api"//正式
// 富文本图片地址
// Vue.prototype.$replaceUrl = "../dev-api" //本地
// // Vue.prototype.$replaceUrl = "prod-api" //测试
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js